export default {"src":"/_next/static/image/src/images/Footer/phone.169330b7310934dbf702a455369fbac9.svg","height":21,"width":11};